import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, ShieldCheck } from "lucide-react";
import { Logo } from "./Logo";

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  const go = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-slate-200/70 bg-white/80 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6">
        <a
          href="/"
          data-testid="nav-logo-link"
          className="transition-opacity hover:opacity-80"
          onClick={(e) => {
            e.preventDefault();
            window.location.href = "/";
          }}
        >
          <Logo />
        </a>

        <nav className="hidden items-center gap-8 md:flex">
          <button
            data-testid="nav-products-link"
            onClick={() => go("products")}
            className="text-sm font-semibold text-slate-600 transition-colors hover:text-[#0F172A]"
          >
            Products
          </button>
          <button
            data-testid="nav-contact-link"
            onClick={() => go("contact")}
            className="text-sm font-semibold text-slate-600 transition-colors hover:text-[#0F172A]"
          >
            Contact
          </button>
          <Link
            to="/admin"
            data-testid="nav-admin-link"
            className="inline-flex items-center gap-1.5 rounded-md border border-slate-200 px-3.5 py-2 text-sm font-semibold text-slate-600 transition-colors hover:border-slate-300 hover:text-[#0F172A]"
          >
            <ShieldCheck className="h-4 w-4" />
            Admin
          </Link>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="rounded-md p-2 text-slate-700 md:hidden"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div className="border-t border-slate-200/70 bg-white px-6 py-4 md:hidden">
          <div className="flex flex-col gap-3">
            <button
              data-testid="nav-mobile-products-link"
              onClick={() => go("products")}
              className="rounded-md px-2 py-2.5 text-left text-sm font-semibold text-slate-700"
            >
              Products
            </button>
            <button
              data-testid="nav-mobile-contact-link"
              onClick={() => go("contact")}
              className="rounded-md px-2 py-2.5 text-left text-sm font-semibold text-slate-700"
            >
              Contact
            </button>
            <Link
              to="/admin"
              data-testid="nav-mobile-admin-link"
              className="rounded-md px-2 py-2.5 text-left text-sm font-semibold text-slate-700"
              onClick={() => setOpen(false)}
            >
              Admin
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};
